export const GET_MEMBER_LIST_BY_COMMUNITY = 'GET_MEMBER_LIST_BY_COMMUNITY';
export const GET_MEMBER_LIST_BY_COMMUNITY_SUCCESS =
  'GET_MEMBER_LIST_BY_COMMUNITY_SUCCESS';
export const GET_MEMBER_LIST_BY_COMMUNITY_ERROR =
  'GET_MEMBER_LIST_BY_COMMUNITY_ERROR';

export const GET_ALL_MEMBER = 'GET_ALL_MEMBER';
export const GET_ALL_MEMBER_SUCCESS = 'GET_ALL_MEMBER_SUCCESS';
export const GET_ALL_MEMBER_ERROR = 'GET_ALL_MEMBER_ERROR';

export const GET_SINGLE_MEMBER = 'GET_SINGLE_MEMBER';
export const GET_SINGLE_MEMBER_SUCCESS = 'GET_SINGLE_MEMBER_SUCCESS';
export const GET_SINGLE_MEMBER_ERROR = 'GET_SINGLE_MEMBER_ERROR';

export const CREATE_MEMBER = 'CREATE_MEMBER';
export const CREATE_MEMBER_SUCCESS = 'CREATE_MEMBER_SUCCESS';
export const CREATE_MEMBER_ERROR = 'CREATE_MEMBER_ERROR';

export const UPDATE_MEMBER = 'UPDATE_MEMBER';
export const UPDATE_MEMBER_SUCCESS = 'UPDATE_MEMBER_SUCCESS';
export const UPDATE_MEMBER_ERROR = 'UPDATE_MEMBER_ERROR';

export const DELETE_MEMBER = 'DELETE_MEMBER';
export const DELETE_MEMBER_SUCCESS = 'DELETE_MEMBER_SUCCESS';
export const DELETE_MEMBER_ERROR = 'DELETE_MEMBER_ERROR';
